var map = {
	"./menu/1.png": "7721",
	"./menu/2.png": "ec9f",
	"./menu/3.png": "aa13",
	"./menu/4.png": "6e72",
	"./qsr/1.png": "4f66",
	"./qsr/2.png": "f724",
	"./qsr/3.png": "2343",
	"./qsr/4.png": "5e45",
	"./qsr/5.png": "72bf",
	"./qsrsms/1.png": "1c9c",
	"./qsrsms/2.png": "8672",
	"./qsrsms/3.png": "48c3",
	"./qsrsms/4.png": "421d",
	"./qsrsms/5.png": "39a8",
	"./wmm/1.png": "ce40",
	"./wmm/2.png": "9bd0",
	"./wmm/3.png": "29dd",
	"./wmm/4.png": "8777",
	"./wmm/5.png": "9aac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5c83";